import { defineComponent as _defineComponent } from 'vue'
import { Structure } from '@/types/structure';
	import StructureCard from './structure-card.vue';
	import { computed, watch, nextTick } from 'vue';
	import { ScrollUtils } from '../../utils/scroll-utils';
	import { isFromCard, selectedStructureId } from '../../store/store';

	
export default /*#__PURE__*/_defineComponent({
  __name: 'structure-list',
  props: {
    structuresList: null
  },
  setup(__props: any) {

const props = __props as {
		structuresList: Structure[];
	};

	

	const selectedStructure = computed(() => props.structuresList.find(s => s.id === selectedStructureId.value));

	/**
	 * Scroll sur la carte lié à la structure
	 */
	watch(selectedStructureId, () => scrollTo());

	/**
	 * Reset le scroll lorsque la liste des structures change
	 */
	watch(() => props.structuresList, () => nextTick(() => resetScroll()));

	/**
	 * Gére la sélection de la structure depuis une carte (card)
	 * @param structureId id de la structure
	 */
	function handleSelectStructure(structureId: number) {
		isFromCard.value = true;
		selectedStructureId.value = structureId;
	}

	/**
	 * Détermine si on doit appliquer un style à la carte liée à la structure
	 * @param structure la structure
	 */
	function isSelected(structure: Structure): boolean {
		if (isFromCard.value) {
			return structure.id === selectedStructureId.value;
		}
		return structure.address.latitude === selectedStructure.value?.address.latitude && structure.address.longitude === selectedStructure.value?.address.longitude;
	}

	/**
	 * Réinitialise le scroll à la première structure
	 */
	function resetScroll(): void {
		const cardContainer = document.getElementById('card-container');
		if (cardContainer) {
			if (window.innerWidth > ScrollUtils.BREAK_POINT_WIDTH) {
				cardContainer.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
			} else {
				cardContainer.scrollTo({
					left: 0,
					behavior: 'smooth'
				});
			}
		}
	}

	/**
	 * Scroll jusqu'à la première structure sélectionné
	 */
	function scrollTo(): void {
		let tempStructureId = selectedStructureId.value;

		if (!isFromCard.value) {
			// Si la sélection provient de la map, on va vérifier s'il y a plusieurs structures avec la même adresse
			const sameAddressStructureList = props.structuresList
				.filter(s => s.address.latitude === selectedStructure.value?.address.latitude && s.address.longitude === selectedStructure.value.address.longitude);
			// Si plusieurs structures ont la même adresse, on scroll jusqu'à la première structure trouvée
			if (sameAddressStructureList.length > 1) {
				tempStructureId = sameAddressStructureList[0].id;
			}
		}

		const cardContainer = document.getElementById('card-container');
		if (cardContainer) {
			const card = document.getElementById(`card-${tempStructureId}`);
			if (card) {
				if (window.innerWidth > ScrollUtils.BREAK_POINT_WIDTH) {
					ScrollUtils.scrollToVertical(cardContainer, card);
				} else {
					ScrollUtils.scrollToHorizontal(cardContainer, card);
				}
			}
		}
	}


return { __sfc: true,props, selectedStructure, handleSelectStructure, isSelected, resetScroll, scrollTo, StructureCard }
}

})